module.exports = __webpack_public_path__ + "static/media/student-summary-win.a337a372.png";